import JavaImg from '../images/Java.png';
import Japanese from '../images/Japanese .png';
import KotlinandJava from '../images/ktlin and Java.png';
import PythonBootcamp from '../images/Python Bootcamp.png';
import Sjogcertificate from '../images/sjog_certificate.jpeg';
import metaBackendDeveloper from '../images/MetaBack-EndDeveloper 13-08-2025.jpg';
import googlecloudcertificate from '../images/GoogleCloud.png';

export const CertifiatesList = [

  {
    //heading: " INDIAN STATES",
    img: metaBackendDeveloper,
    title: "Meta Back-End Developer Professional Certificate",
    description:
      "Completed Meta's professional certificate program on back-end development. Gained expertise in Python, Django, APIs, databases, and version control. Built and deployed real-world projects applying back-end principles, cloud integration, and Agile practices.",
  
  },

  {
    //heading: " INDIAN STATES",
    img: googlecloudcertificate,
    title: "Google Cloud Fundamentals Certificate",
    description:
      "Completed Google's foundational course on cloud computing with Google Cloud. Gained hands-on experience with Compute Engine, App Engine, Cloud Storage, BigQuery, and Kubernetes. Learned core concepts of networking, IAM, security, and scaling applications in the cloud. Deployed real-world solutions using Cloud Marketplace and practiced managing resources through the Google Cloud Console and CLI."
  },

  {
    //heading: " INDIAN STATES",
    img: PythonBootcamp,
    title: " 100 Days Python Bootcamp",
    description:
      "Completed a comprehensive 100-day journey into Python programming. Learned core concepts including OOP, web development with Flask, automation, data analysis, and APIs. Built real-world projects such as web scrapers, games, and fullstack apps using Python.",
  
  },

  {
    
    img: JavaImg,
    title: "Java Programming",
    description:
    "Developed solid command over Java from scratch to advanced topics. Learned object-oriented programming, data structures, exception handling, and core Java APIs. Built projects and mastered Java logic building useful for both backend and Android development.",
  },

  {
    
    img: Sjogcertificate,
    title: "Certificate for Significant Contribution",
    description:
    "Awarded for playing a key role as the backend developer in a collaborative team project focused on inclusive design. Took ownership of implementing core backend functionalities while actively supporting team members in their respective roles, including frontend development and user testing. Demonstrated strong technical leadership, cross-functional collaboration, and effective communication throughout the project.",
  },

  {
    //heading: "E.M.S",
    img: KotlinandJava,
    title: "Android Studio (Kotlin and Java)",
    description:
    "Learned to build Android apps from scratch using both Java and Kotlin. Covered Android Studio, UI design, activities, fragments, and integrating APIs. Built functional mobile apps and understood the lifecycle of Android development.",
  },
  


  {
    //heading: "AṞIVU",
    img: Japanese,
    title: "Japanese for Beginner",
    description:
      "Gained a strong foundation in the Japanese language, including grammar, vocabulary, sentence structure, and pronunciation. Practiced basic conversational skills and cultural nuances — enhancing my global mindset and communication skills.",
  },

];
